// extracted by mini-css-extract-plugin
export default {"root":"Rename_root__Qgjhp"};